import { programs, cardTypes } from './programs'

export const parseQueryString = queryString => {
  // the substring removes the leading ?
  const keyValuePairs = queryString.substring(1).split('&');
  return keyValuePairs.reduce((result, pair) => {
    const split = pair.split('=');
    return Object.assign(result, {
      [split[0]]: split[1]
    })
  }, {});
};

const getCardTypeAndDescription = (club, program) => {
  const description = club.desc.indexOf(' - ') !== -1 ? club.desc.toLowerCase().split(' - ')[1] : club.desc.toLowerCase();
  const cardType = cardTypes
    .filter( cardType => programs[program].supportedCards.indexOf(cardType.type) !== -1 )
    .find( cardType => description.indexOf(cardType.matcher) !== -1 )
  if (cardType) {
    return {
      cardType: cardType.type,
      description: cardType.name
    }
  } else {
    const getDescription = () => {
      if(club.desc.indexOf(' - ') !== -1) {
        const split = club.desc.split(' - ');
        return split[split.length - 2];
      }
      return club.desc;
    }
    return {
      cardType: 'default-club',
      description: getDescription()
    }
  }
}
const processProgressMessage = (club, missing) => {
  // Legacy: %d is replaced with how many punches are left. New API returns the full text.
  if (club.progressMsg.indexOf('%d') === -1) {
    return club.progressMsg
  }
  const splitMessage = club.progressMsg.split('%d')
  return splitMessage[0].concat(missing, splitMessage[1])
}

export const preProcessClub = (club, program) => {
  let { cardType, description } = getCardTypeAndDescription(club, program)
  const missing = club.numberToGet - club.currentPunches
  const progressMessage = processProgressMessage(club, missing)
  const awardMessage = club.awardMsg !== '' ? club.awardMsg : 'Your next one is free!'
  const statusText = missing <= 0 ? awardMessage : progressMessage
  const displayDescriptionAndLocation = program !== 'noco'

  // custom club/program settings - some kickback programs need additional processing
  if (program.toLowerCase() === 'rocket') {
    if (!club.clubPunchedUrl || club.clubPunchedUrl.length === 0) {
      // set punched and not punched URLs, don't rely on rewards butler to have these correct
      club.clubPunchedUrl = '/img/rocket/PunchedBlueCircle.png'
      club.clubNotPunchedUrl = '/img/rocket/BlueCircle.png'
      // some clubs need different punched/un-punched image(s) from the default
      if (cardType === "coffee-club"){
        club.clubPunchedUrl = '/img/rocket/PunchedBrownCircle.png'
        club.clubNotPunchedUrl = '/img/rocket/BrownCircle.png'
      }
    }

  }

  if (program.toLowerCase() === 'kickback') {
    if (!club.clubPunchedUrl || club.clubPunchedUrl.length === 0) {
      // set punched and not punched URLs, don't rely on rewards butler to have these correct
      club.clubPunchedUrl = '/img/kickback/ftn_drink_p66_starcircle.png'
      club.clubNotPunchedUrl = '/img/kickback/ftn_drink_p66_circle.png'
    }

  }

  return {
    ...club,
    cardType,
    description,
    statusText,
    displayDescriptionAndLocation
  }
}



// WEBPACK FOOTER //
// ./src/store/utils.js